<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="Filial"
          outlined
          multiple
          hide-details
          :qtdeVisivelSelecionados="1"
          :idsGrupo="filtros.grupos"
        />
      </div>
    </div>

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
      label="Segmentos"
      :idsGrupo="filtros.grupos"
      :idsFilial="filtros.filiais"
      :qtdeVisivelSelecionados="1"
    />

    <SysCompradorAutocomplete 
      v-model="filtros.compradores"
      outlined
      multiple
      hide-details
      class="mt-4"
      label="Compradores"
      :idsGrupo="filtros.grupos"
      :idsFilial="filtros.filiais"
      :idsSegmento="filtros.segmentos"
      :qtde_visivel_selecionados="1"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      outlined
      multiple
      hide-details
      class="mt-4"
      label="Fornecedores"
      :idsGrupo="filtros.grupos"
      :idsFilial="filtros.filiais"
      :idsSegmento="filtros.segmentos"
      :idsComprador="filtros.compradores"
      :qtdeVisivelSelecionados="1"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import Api from "@/api/api";

export default {
  name: "AnaliseBalanceamento",
  mixins: [Mixin],
  components: {
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      filiais: [],
      segmentos: [],
      fornecedores: [],
      compradores: []
    }
  }),
  methods: {
    // gerarRelatorio() {
    //   let url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl({...this.filtros, id_usuario: localStorage.getItem('id')})}`;
    //   window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
    //   this.DIALOG_ATIVO = false;
    // }
    gerarRelatorio() {
      const filtros = {
        ...this.filtros,
        id_usuario: localStorage.getItem('id')
      };

      Api({
        url: `${this.relatorio.url}`,
        method: 'POST',
        data: filtros,
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `RELATORIO-DE-ANALISE-DE-BALANCEAMENTO-${this.dataHoje()}.csv`);

          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          alert('Erro ao gerar o relatório, ' + error);
          console.error('Erro ao gerar o relatório:', error);
        });

      this.DIALOG_ATIVO = false;
    },
    dataHoje() {
      const hoje = new Date();
      const dia = String(hoje.getDate()).padStart(2, '0');
      const mes = String(hoje.getMonth() + 1).padStart(2, '0');
      const ano = hoje.getFullYear();
      return `${dia}-${mes}-${ano}`;
    }
  }
}
</script>

<style scoped>

</style>
